import * as React from "react";

const s = require("./submitButton.scss");

interface Props {

}

function SubmitButton(props: Props) {
    return (
        <button type="submit" className={s.submitButton}>
            <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
        </button>
    );
}

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/FormElements/Buttons/SubmitButton/index.tsx